import * as React from 'react';
import { css } from 'aphrodite/no-important';
import { SectionHeader } from '../../wrappers/sectionHeader/SectionHeader';
import { H1 } from '../../../typography/semanticTags';
import { HighlightsArticleList } from './HighlightsArticleList';
import { sectionStyle } from '../pageLayouts/layout.utils';
import { CardComponentDataProps } from '../../partials/cards/cards.utils';

interface HeaderWithHighlightsProps {
  title: string;
  cardsProps: CardComponentDataProps[];
}

export const HeaderWithHighlights: React.FunctionComponent<HeaderWithHighlightsProps> = ({ title, cardsProps }) => {
  return (
    <section className={css(sectionStyle)}>
      <SectionHeader linkText={null} href={null}>
        <H1>{title}</H1>
      </SectionHeader>
      <HighlightsArticleList cardsProps={cardsProps} />
    </section>
  );
};
